import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa';
import { Reveal } from '../motion/Reveal';

/** A3 comparison — table desktop, tabs mobile. */
const HomeCompare = () => {
  const { t } = useTranslation();
  const { language } = useParams();
  const a = t('home.compare', { returnObjects: true }) || {};
  const head = Array.isArray(a.head) ? a.head : [];
  const rows = Array.isArray(a.rows) ? a.rows : [];
  const [tab, setTab] = useState(2);

  return (
    <section className="home-odam-section home-odam-section--soft" id="compare">
      <div className="container">
        <Reveal>
          <h2 className="home-odam-h2">{a.title}</h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="home-odam-lead">{a.lead}</p>
        </Reveal>

        <div className="home-odam-table-wrap">
          <table className="home-odam-table">
            <thead>
              <tr>
                <th scope="col" />
                {head.map((h, i) => (
                  <th key={i} scope="col" className={i === 2 ? 'is-accent' : undefined}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <th scope="row">{r[0]}</th>
                  <td>{r[1]}</td>
                  <td>{r[2]}</td>
                  <td className="is-accent">
                    <span className="home-odam-table__check">
                      <FaCheck aria-hidden="true" />
                      {r[3]}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="home-odam-tabs">
          <div className="home-odam-tabs__list" role="tablist">
            {head.map((h, i) => (
              <button
                key={i}
                type="button"
                role="tab"
                aria-selected={tab === i}
                className={tab === i ? 'is-active' : undefined}
                onClick={() => setTab(i)}
              >
                {h}
              </button>
            ))}
          </div>
          <div className="home-odam-tabs__panel" role="tabpanel">
            {rows.map((r, j) => (
              <div key={j} className="home-odam-tabs__row">
                <strong>{r[0]}</strong>
                <p>{r[tab + 1]}</p>
              </div>
            ))}
          </div>
        </div>

        {a.note ? <p className="home-odam-note">{a.note}</p> : null}
        <p className="lumi-compare-more">
          <Link to={`/${language || 'en'}/how-lumi-works`}>{t('lumi.compare_more')}</Link>
        </p>
      </div>
    </section>
  );
};

export default HomeCompare;
